import React from "react"
export function Info(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <g
        id="prefix__Artboard-Copy-30"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1C4.141 1 1 4.141 1 8s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm.77 6.033v5.5h-1.5v-5.5h1.5zm-.75-3.5a1 1 0 110 2 1 1 0 010-2z"
          id="prefix__Combined-Shape"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
